<template>
    <article v-if="event.show && event.filter"
        :style="{'border-left':`8px solid ${event.color}`}"
        class="TcEventItem bg-white p-5 flex relative gap-5 shadow-md overflow-hidden">
        <div>
            <div class="text-5xl font-bold mb-2">{{ getDay }}</div>
            <div class="text-xl">{{ getMonth }}</div>
        </div>
        <div class="flex-grow">
            <div>
            <div class="text-xl font-bold">{{ event.name }}</div>
            <div class="flex mt-1 mb-10 items-center">
                <div :style="{'background-color':event.color}"
                    class="text-white text-sm py-1 px-6 mr-3 rounded-full">
                    {{ event.category_name }}
                </div>
                <div v-if="event.amount" class="coin-euro">Precio: <strong>{{ event.amount.strToEuro() }}</strong></div>
            </div>
            <div class="host mb-2">Organiza: {{ event.host_name }}</div>
            <div class="location mb-2">{{ event.venue }}</div>
            <div class="group" v-html="getAvailable">Plazas</div>
            </div>
        </div>
        <div v-if="!hide_buttons" class="flex flex-col gap-3">
            <button v-if="!subscribed" @click="$parent.subscribeEvent(event)" class="btn-sm w-full">Inscribirme</button>
            <span v-else class="text-center font-bold text-green-500"> Ya inscrito </span>
            <button v-if="!hide_info" @click="$parent.moreInfo(event)" class="btn-sm w-full btn-secondary">Más información</button>
        </div>
        <div v-if="hasPaymentStatus"
            class="paid-status"
            :class="{'payed': isPaid, 'unpayed': !isPaid}">
            {{ isPaid ? 'PAGADO' : 'PENDIENTE DE PAGO' }}
        </div>
    </article>
</template>
<style scoped>
.paid-status {
    position: absolute;
    right: -70px;
    top: 30px;
    color: #FFF;
    width: 250px;
    padding: 1rem;
    height: 3rem;
    font-size: 12px;
    text-align: center;
    transform-origin: 50% 50%;
    transform: rotate(45deg);
    box-shadow: 0px 2px 5px rgba(0,0,0,.5);
}
.paid-status.payed {
    background-color: green;
}
.paid-status.unpayed {
    background-color: red;
}
</style>
<script>
export default {
    name: 'TcEventItem',
    //props: ['event','hide_info','hide_buttons', 'subscribed'],
    props: {
        event: {
            default: null
        },
        hide_info: {
            default: false
        },
        hide_buttons: {
            default: false
        },
        subscribed: {
            default: false
        }
    },
    computed: {
        getDay: function() {
            return this.$props.event.start_date.split('/')[0];
        },
        getMonth: function() {
            return ['DIC','ENE','FEB','MAR','ABR','MAY','JUN','JUL','AGO','SEP','OCT','NOV','DIC']
            [parseInt(this.$props.event.start_date.split('/')[1])];
        },
        getAvailable: function() {
            if(this.$props.event.remaining_capacity==99999 || !this.$props.event.capacity) {
                return 'Sin límite de plazas'
            }
            return `Quedan <strong>${this.$props.event.remaining_capacity} plazas disponibles</strong>
                (${this.$props.event.remaining_capacity}/${this.$props.event.capacity})`;
        },
        hasPaymentStatus: function() {
            const paid = this.event.paid;
            return paid === true || paid === false;
        },
        isPaid: function() {
            return this.event.paid === true;
        },
    },
    data () {
        return {}
    },
}
</script>
